import React, { useContext, useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';

import Cookies from 'js-cookie';


function PrivateRouter({ component: Component, ...rest }) {
    const { isAuth } = useContext(AuthContext);

    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        setAuthChecked(true);
    }, [isAuth]);

    if (!authChecked) {
        // Ne rend rien tant que l'authentification n'a pas été vérifiée
        return null;
    }
    const token = Cookies.get('token');
    return (

        <Route
            {...rest}
            render={routeProps => {
                if (token || isAuth) {
                    return <Component {...routeProps} />;
                } else {
                    return <Redirect to={{ pathname: "/signin", state: { from: routeProps.location } }} />;
                }
            }}
        />
    );
}

export default PrivateRouter